import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const RegistrationHeader = () => {
  const navigate = useNavigate();

  return (
    <div className="text-center space-y-2 md:space-y-3">
      <div className="flex justify-center mb-4 md:mb-6">
        <div className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 rounded-2xl bg-gradient-to-br from-primary to-accent flex items-center justify-center shadow-lg">
          <span className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-primary-foreground">
            AC
          </span>
        </div>
      </div>

      <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground">
        Create Your Account
      </h1>
      
      <p className="text-sm md:text-base text-muted-foreground max-w-md mx-auto">
        Join thousands of creators building amazing web applications without code
      </p>

      <div className="flex items-center justify-center gap-2 pt-2">
        <span className="text-sm text-muted-foreground">
          Already have an account?
        </span>
        <button
          onClick={() => navigate('/login')}
          className="text-sm font-medium text-primary hover:underline inline-flex items-center gap-1 transition-colors"
        >
          Sign in
          <Icon name="ArrowRight" size={16} />
        </button>
      </div>
    </div>
  );
};

export default RegistrationHeader;